import {
  SAVED_CART_LOAD_ERROR,
  SAVED_CART_LIST_RECEIVE,
  SAVED_CART_OPEN,
  SAVED_CART_CLOSE,
  SAVED_CART_PRODUCT_SELECTION,
  SAVED_CART_PRODUCT_DESELECTION,
  UPDATE_CART_ROW_STATUS,
  UPDATE_CART_ROW_INIT_STATUS,
  SAVED_CART_LIST_ADD_TO_CART_CLEAR,
  DELETE_CART,
  UPDATE_CART_NAME,
} from '../constants';
import { error as errorReducer } from './Error.reducer';

const initialState = {
  isOpen: false,
  selectedUserId: '',
  showUpdateButton: false,
  selectedCart: null,
  selectedOrderId: null,
  loadingStatus: 'Completed',
  savedCartName: null,
  savedCarts: [],
  errors: {},
  selectedOrderRowList: [],
  cartRowStatusList: [],
};

export const savedCart = (state = initialState, action) => {
  switch (action.type) {
    case SAVED_CART_LIST_RECEIVE:
      return {
        ...state,
        ...action.payload,
        cartRowStatusList: [],
      };
    case SAVED_CART_LOAD_ERROR:
      return {
        ...state,
        errors: errorReducer(state.errors, action),
      };
    case SAVED_CART_OPEN:
      return {
        ...state,
        isOpen: true,
        selectedOrderId: action.payload,
      };

    case SAVED_CART_CLOSE:
      return {
        ...state,
        isOpen: false,
        selectedOrderId: null,
      };

    case SAVED_CART_PRODUCT_SELECTION:
      return {
        ...state,
        selectedOrderRowList: [...state.selectedOrderRowList, action.payload],
        cartRowStatusList: state.cartRowStatusList.filter(
          (id) => id !== action.payload
        ),
      };

    case SAVED_CART_PRODUCT_DESELECTION:
      return {
        ...state,
        selectedOrderRowList: state.selectedOrderRowList.filter(
          (id) => id !== action.payload
        ),
        cartRowStatusList: state.cartRowStatusList.filter(
          (x) => x.id !== action.payload
        ),
      };

    case UPDATE_CART_ROW_STATUS:
      return {
        ...state,
        cartRowStatusList: state.cartRowStatusList.map((item) =>
          item.id === action.payload.id
            ? { ...item, rowStatus: action.payload.rowStatus }
            : item
        ),
      };

    case UPDATE_CART_ROW_INIT_STATUS:
      return {
        ...state,
        cartRowStatusList: [
          ...state.cartRowStatusList,
          ...action.payload.cartRowStatusList,
        ],
      };

    case SAVED_CART_LIST_ADD_TO_CART_CLEAR:
      return {
        ...state,
        ...action.payload,
      };

    case DELETE_CART:
      return {
        ...state,
        savedCarts: state.savedCarts.map((cart) =>
          cart.cartId === action.payload.cartId
            ? { ...cart, isDelete: true }
            : cart
        ),
      };

    case UPDATE_CART_NAME:
      return {
        ...state,
        savedCarts: state.savedCarts.map((cart) =>
          cart.cartId === action.payload.cartId
            ? { ...cart, name: action.payload.name, isUpdated: true }
            : cart
        ),
        selectedCart:
          state.selectedCart &&
          state.selectedCart.cartId === action.payload.cartId
            ? { ...state.selectedCart, savedCartName: action.payload.name }
            : state.selectedCart,
      };
    default:
      return state;
  }
};
